import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { TICKETS_ROUTE } from '../../../../../constants/Routes';
import { useEmptyStateTextStyles } from './styles';

const EmptyStateText = () => {
  const classes = useEmptyStateTextStyles();
  return (
    <React.Fragment>
      <Typography className={classes.typo1}>
        Lo sentimos, en este momento no podemos realizar tu solicitud de
        atención. Por favor, vuelve más tarde.
      </Typography>
      <Typography>
        Si necesitas reportar un inconveniente urgente, puedes crear tu
        solicitud en nuestro formulario de contacto y quedará registrada en
        <Link className={classes.link} to={TICKETS_ROUTE}>
          {' '}
          <strong>“Solicitudes de atención”.</strong>
        </Link>
      </Typography>
    </React.Fragment>
  );
};

export default EmptyStateText;
